import _DoubleLeftOutlined from "@ant-design/icons/es/icons/DoubleLeftOutlined";
import _DoubleRightOutlined from "@ant-design/icons/es/icons/DoubleRightOutlined";
import { useUpdateEffect } from 'ahooks';
import classNames from 'classnames';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import ConfigProvider from '@baifendian/adhere-ui-configprovider';
import { gridCount } from './Fixed';
import { getValueWithUnit } from './Util';
// import { ResizeObserver } from '@juggle/resize-observer';
/**
 * useGrid
 * @description 是否使用了栅格系统
 * @param {FixedProps} props
 * @return {boolean}
 */
export var useGrid = function (props) {
  return useMemo(function () {
    return 'span' in props && typeof props.span === 'number' && props.span >= 0 && props.span <= gridCount;
  }, [props.span]);
};
/**
 * useGap
 * @param {number | number[]} gutter
 * @return {boolean}
 */
export var useGap = function (gutter) {
  return useMemo(function () {
    if (gutter === undefined || gutter === null || gutter === '' || gutter === 0 || typeof gutter === 'function' || typeof gutter === 'object' && !Array.isArray(gutter)) {
      return false;
    }
    if (Array.isArray(gutter)) {
      if (gutter.length === 0) return false;
      if (gutter.length >= 1 && gutter.length <= 2) {
        return !gutter.some(function (g) {
          return g === undefined || g === null || g === '' || typeof g !== 'number';
        });
      }
    }
    return true;
  }, [gutter]);
};
/**
 * useTrigger
 */
export var useTrigger = function (_a) {
  var trigger = _a.trigger,
    _b = _a.collapseDirection,
    collapseDirection = _b === void 0 ? 'L' : _b,
    _c = _a.collapsedSize,
    collapsedSize = _c === void 0 ? 80 : _c,
    _d = _a.defaultCollapsible,
    defaultCollapsible = _d === void 0 ? false : _d,
    onCollapse = _a.onCollapse,
    selectorPrefix = _a.selectorPrefix,
    elRef = _a.elRef;
  var media = useContext(ConfigProvider.Context).media;
  var targetCollapsedSize = useMemo(function () {
    return getValueWithUnit(collapsedSize, media);
  }, [collapsedSize]);
  var _e = useState(defaultCollapsible),
    collapsible = _e[0],
    setCollapsible = _e[1];
  // 缺省的Trigger元素
  var DefaultTrigger = useMemo(function () {
    if (collapseDirection === 'L') {
      if (collapsible) {
        return /*#__PURE__*/React.createElement(_DoubleRightOutlined, null);
      } else return /*#__PURE__*/React.createElement(_DoubleLeftOutlined, null);
    } else if (collapseDirection === 'R') {
      if (collapsible) {
        return /*#__PURE__*/React.createElement(_DoubleLeftOutlined, null);
      } else return /*#__PURE__*/React.createElement(_DoubleRightOutlined, null);
    } else if (collapseDirection === 'T') {
      if (collapsible) {
        return /*#__PURE__*/React.createElement(_DoubleRightOutlined, {
          style: {
            transform: 'rotate(90deg)'
          }
        });
      } else return /*#__PURE__*/React.createElement(_DoubleLeftOutlined, {
        style: {
          transform: 'rotate(90deg)'
        }
      });
    } else if (collapseDirection === 'B') {
      if (collapsible) {
        return /*#__PURE__*/React.createElement(_DoubleLeftOutlined, {
          style: {
            transform: 'rotate(90deg)'
          }
        });
      } else return /*#__PURE__*/React.createElement(_DoubleRightOutlined, {
        style: {
          transform: 'rotate(90deg)'
        }
      });
    }
  }, [collapseDirection, collapsible]);
  // 渲染Trigger
  var renderTrigger = useCallback(function () {
    if (trigger) {
      var triggerInner = trigger === null || trigger === void 0 ? void 0 : trigger(collapsible, DefaultTrigger);
      if (triggerInner) {
        return /*#__PURE__*/React.createElement("div", {
          className: classNames("".concat(selectorPrefix, "-trigger"), "".concat(selectorPrefix, "-trigger-").concat(collapseDirection === null || collapseDirection === void 0 ? void 0 : collapseDirection.toLowerCase())),
          onClick: _onCollapse
        }, triggerInner);
      }
      return null;
    }
    return null;
  }, [trigger, collapseDirection, DefaultTrigger]);
  var collapseStyle = useMemo(function () {
    // 关闭
    if (collapsible) {
      if (collapseDirection === 'L') {
        return {
          maxWidth: targetCollapsedSize
        };
      } else if (collapseDirection === 'R') {
        return {
          maxWidth: targetCollapsedSize
        };
      } else if (collapseDirection === 'T') {
        return {
          maxHeight: targetCollapsedSize
        };
      } else if (collapseDirection === 'B') {
        return {
          maxHeight: targetCollapsedSize
        };
      }
      return {};
    }
    // 显示
    if (collapseDirection === 'L') {
      return {
        maxWidth: '100%'
      };
    } else if (collapseDirection === 'R') {
      return {
        maxWidth: '100%'
      };
    } else if (collapseDirection === 'T') {
      return {
        maxHeight: '100%'
      };
    } else if (collapseDirection === 'B') {
      return {
        maxHeight: '100%'
      };
    }
    return {};
  }, [collapseDirection, collapsible, targetCollapsedSize]);
  useUpdateEffect(function () {
    setCollapsible(defaultCollapsible);
  }, [defaultCollapsible]);
  /**
   * _onCollapse
   */
  function _onCollapse() {
    setCollapsible(!collapsible);
    onCollapse === null || onCollapse === void 0 ? void 0 : onCollapse(!collapsible);
  }
  return {
    renderTrigger: renderTrigger,
    collapseStyle: collapseStyle
  };
};